import schema from "@components/faqSchema/zoho-integration.json";
import FeatureCard, { FeatureCardItemProps } from "@components/FeatureCardV2";
import ClientLogos from "@components/new-ui/ClientLogos";
import Head from "next/head";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import AwardsSection from "@components/new-ui/AwardsSection";
import CTASection from "@components/new-ui/CTASection";
import NewLayout from "@components/new-ui/Layout";
const scriptText = JSON.stringify(schema, null, 2);

const herosectionData: HerosectionProps = {
    chipTitle: "WHATSAPP PIPEDRIVE INTEGRATION",
    title: "Seamlessly collect information and automatically create leads in Pipedrive",
    description: "Gallabox helps you automate the enaggement of your Pipedrive contacts on WhatsApp, helping you meet them where they are.",
    primaryButtonText: "Try for free",
    imageUrl: "https://assets.gallabox.com/gb-home/lp/pipedrive/pipedrive-hero-image.png",
};
const featureCardInput: FeatureCardItemProps[] = [
    {
        chipTitle: "No code setup",
        title: "Integrate your WhatsApp to Pipedrive with just a few clicks",
        description:
            "Sync Pipedrive accounts and deals with Gallabox and streamline your WhatsApp customer engagement workflow. The predefined templates with module fields help you reach prospects and customers with the right message based on customer actions and events. Save time and improve your productivity.",

        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/lp/pipedrive/pipedrive-1.png",
        mediaAltText: "WhatsApp  Pipedrive integrations ",
        mediaPosition: "right",
    },
    {
        chipTitle: "Personalized WhatsApp messages",
        title: "Initiate WhatsApp conversations from within Pipedrive",
        description:
            "With Gallabox’s deep native integration with Pipedrive, you don’t need to leave your Pipedrive interface to send personalized WhatsApp messages to your Pipedrive contacts. Also, check the conversation history and get the context of WhatsApp engagements of each account within Pipedrive.",

        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/lp/pipedrive/pipedrive-2.gif",
        mediaAltText: "WhatsApp conversations ",
        mediaPosition: "right",
    },
    {
        chipTitle: "Shared Team Inbox",
        title: "Offer a seamless customer experience by democratizing customer context.",
        description:
            "With Gallabox’s team inbox, share the customer context of your Pipedrive contacts seamlessly across your team so that multiple agents can take over conversations of all your Pipedrive accounts without any context loss, offering a seamless customer experience.",

        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/lp/pipedrive/pipedrive-3.png",
        mediaAltText: "Shared Team Inbox ",
        mediaPosition: "right",
    },
];

const Pipedrive: React.FC = () => {
    return (
        <section className="bg-white">
            <NewLayout
                title="WhatsApp Pipedrive Integration | Engage Pipedrive contacts on WhatsApp | Gallabox"
                description="Pipedrive Integration with WhatsApp via Gallabox can be up and running in minutes without the need for any code. With this integration, you can now engage your Pipedrive contacts better with streamlined WhatsApp workflows."
                ogAttributes={{ image: "https://assets.gallabox.com/gb-home/lp/pipedrive/pipedrive-hero-image.png" }}
            >
                <Head>
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: scriptText }} />
                </Head>

                <div className="mt-12 md:mt-0">
                    <Herosection herosection={herosectionData} />
                </div>

                <div className="lg:max-w-7xl mx-auto lg:mt-0 mt-20">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>

                <FeatureCard mobileView="content-first" cardData={featureCardInput} version="v2" chipTitleVersion="v2" />

                <section className="my-10 lg:my-0">
                    <IntegrationSection isLight />
                </section>
                <AwardsSection />
                <CTASection title="Turn connections into conversions" description="Be among the first to ride the automation wave" />
            </NewLayout>
        </section>
    );
};

export default Pipedrive;
